import { VisualSuper } from "./visual-super.component.js";

class Image extends VisualSuper {
  namespace = "visual:image";

  receiveMessage(node, message) {
    switch (message.key) {
      case "image_loaded": {
        this.dispatch(`${node.uid}:loaded`);
        break;
      }
      case "image_load_error": {
        console.warn(`Image cannot be loaded.`, node.props["source.url"] || node.props["source.imageId"]);
        break;
      }
      default: {
        super.receiveMessage(node, message);
      }
    }
  }
}

const image = new Image();
export { Image, image };
